<template>
  <div class="flex">
    <div class="bg-white rounded-md shadow" v-if="applicant">
      <div class="flex flex-wrap -mt-3 p-8">
        <h3 class="text-xl font-medium leading-6 text-gray-900 block pb-8 w-full">{{$t('applications.applicant')}}</h3>
        <label class="font-medium pb-5 pr-6 2xl:w-1/3 w-2/4">
          {{$t('global.name')}}
        </label>
        <div class="pb-5 pr-6 2xl:w-2/3 w-2/4">
          <span v-if="viaVolunteer">
            {{applicant.name}}
          </span>
          <Link v-else tooltip="" class="flex items-center focus:text-indigo-500 underline" :href="`/applicants/${applicant.id}/view`">
            {{applicant.name}}
          </Link>

        </div>
        <label class="font-medium pb-5 pr-6 2xl:w-1/3 w-2/4">
          {{$t('applicants.date_birth')}}
        </label>
        <div class="pb-5 pr-6 2xl:w-2/3 w-2/4">
          {{$filters.formatDate(applicant.date_birth)}}
        </div>
        <label class="font-medium pb-5 pr-6 2xl:w-1/3 w-2/4">
          {{$t('applicants.gender')}}
        </label>
        <div class="pb-5 pr-6 2xl:w-2/3 w-2/4">
          {{applicant.gender}}
        </div>
        <label class="font-medium pb-5 pr-6 2xl:w-1/3 w-2/4">
          {{$t('applicants.languages')}}
        </label>
        <div class="pb-5 pr-6 2xl:w-2/3 w-2/4">
          {{ applicant.language.join(', ') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3'
export default{
  props:{
    applicant: Object,
    viaVolunteer: {
      type: Boolean,
      default: false
    },
  },
  components:{Link}
}
</script>
